module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_mobile-a9adaf8a0370a54de94bf0fcfb9bc8a4.jpg";